import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Avatar,
  Modal,
  Form,
  Input,
  Select,
  Row,
  Col,
  Space,
  Card,
  Checkbox,
  notification,
  Menu,
  Dropdown,
  Tag,
  Tooltip,
} from "antd";
import {
  UserOutlined,
  EditOutlined,
  LockOutlined,
  UnorderedListOutlined,
  RollbackOutlined,
} from "@ant-design/icons";
import "./index.css";
import DefaultLayout from "./../../components/layout/DefaultLayout";
import Header from "../../components/header";
import userService from "../../services/user";
import sectionService from "../../services/section";
import roleService from "../../services/role";
import authService from "../../services/auth";
import auth from "../../services/auth";
import { useMediaQuery } from "react-responsive";
import { Excel } from "antd-table-saveas-excel";
import LocationComponent from "../../components/location";
import DesignationComponent from "../../components/designation";
import DepartmentComponent from "../../components/department";
import RoleComponent from "../../components/role";
import CompanyComponent from "../../components/company";

const RestoreUsersData = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form] = Form.useForm();
  const [formPassword] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [sections, setSections] = useState([]);

  const [selectLoading, setSelectLoading] = useState(false);

  const [roles, setRoles] = useState([]);
  const [isProfilePictureModalVisible, setIsProfilePictureModalVisible] =
    useState(false);
  const [isChangePasswordModalVisible, setIsChangePasswordModalVisible] =
    useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const getDepartmentOfSection = async (departmentId) => {
    setSelectLoading(true);
    try {
      const response = await sectionService.getDepartmentOfSection(
        departmentId
      );
      console.log("Department sections:", response);

      if (Array.isArray(response) && response.length > 0) {
        setSections(response);
      } else {
        setSections([]);
        form.setFieldsValue({
          section_id: null,
        });
      }
    } catch (error) {
      console.error("Error fetching department sections:", error);
      notification.error({
        message: "Error",
        description: error.response ? error.response : "An error occurred",
      });
    } finally {
      setSelectLoading(false);
    }
  };

  const getRoles = async () => {
    try {
      const response = await roleService.getRoles();
      setRoles(response);
    } catch (error) {}
  };

  useEffect(() => {
    getRoles();
  }, []);

  const getUsers = async (page = 1, itemsPerPage = 15, searchQuery = "") => {
    setLoading(true);
    try {
      const response = await userService.getTrashedUsers(
        page,
        itemsPerPage,
        searchQuery
      );
      console.log("yess");
      console.log(response);
      setData(response.data);
      setCurrentPage(response.meta.current_page);
      setTotalDataCount(response.meta.total);
      setItemsPerPage(response.meta.per_page);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const handleTableChange = (pagination) => {
    getUsers(pagination.current, itemsPerPage, searchQuery);
  };

  const handleInputChange = (event) => {
    const newSearchQuery = event.target.value;
    setSearchQuery(newSearchQuery);
    if (newSearchQuery.length > 2 || newSearchQuery === "") {
      getUsers(1, itemsPerPage, newSearchQuery);
    }
  };

  const handleRestore = async (rrr) => {
    console.log(rrr.id);
    try {
      setLoading(true);
      const response = await userService.restoreTrashedUser(rrr.id);
      setLoading(false);
      if (response.success) {
        notification.success({
          message: "Success",
          description: response.message,
        });
        getUsers();
      } else {
        notification.error({
          message: "Error",
          description: response.message,
        });
      }
    } catch (error) {
      console.error("Error Delete request:", error);
      setLoading(false);
      notification.error({
        message: "Error",
        description:
          error.response?.data?.message ||
          "There was an error sending the Delete request.",
      });
    }
  };
  const columns = [
    {
      title: "Full Name",
      key: "name",
      dataIndex: "name",
      width: 260,
      fixed: useMediaQuery({ minWidth: 768 }) ? "left" : null,
      render: (text, record) => {
        {
          console.log("yeh hain users ", record);
        }
        return (
          <div>
            <Avatar
              size={32}
              className="mr-10"
              src={record?.profile_photo_path}
              icon={
                !record?.profile_photo_path && <UserOutlined /> // Correct the condition here
              }
            />
            {text && <span>{text}</span>}
          </div>
        );
      },
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 300,
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Company",
      dataIndex: ["company", "name"],
      key: "company", // Changed key to 'company'
      width: 150,
      sorter: (a, b) => a.company.name.localeCompare(b.company.name),
      render: (text, record) => {
        return record.company && record.company.name
          ? record.company.name
          : "-";
      },
    },
    {
      title: "Designation",
      dataIndex: ["designation", "name"],
      key: "designation",
      width: 180,
      sorter: (a, b) => {
        const aDesignation = a.designation && a.designation.name;
        const bDesignation = b.designation && b.designation.name;
        return aDesignation.localeCompare(bDesignation);
      },
      render: (text, record) => {
        return (
          <div>
            <span>{text}</span>
          </div>
        );
      },
    },
    {
      title: "Employee No",
      dataIndex: "employee_no",
      key: "employee_no",
      width: 140,
      sorter: (a, b) => a.employee_no.localeCompare(b.employee_no),
    },
    {
      title: "Employee Type",
      dataIndex: "employee_type",
      key: "employee_type",
      width: 170,
      sorter: (a, b) => a.employee_type.localeCompare(b.employee_type),
    },
    {
      title: "Extension",
      dataIndex: "extension",
      key: "extension",
      width: 100,
      sorter: (a, b) => {
        const extensionA = a.extension || "";
        const extensionB = b.extension || "";
        return extensionA.localeCompare(extensionB);
      },
    },
    {
      title: "Phone",
      dataIndex: "phone_number",
      key: "phone_number",
      width: 160,
      sorter: (a, b) => a.phone_number.localeCompare(b.phone_number),
    },
    {
      title: "Location",
      dataIndex: ["location", "name"],
      key: "location",
      sorter: (a, b) => a.location.name.localeCompare(b.location.name),
      width: 140,
    },
    {
      title: "Department",
      dataIndex: ["department", "name"],
      key: "department_id",
      width: 150,
      sorter: (a, b) => a.department.name.localeCompare(b.department.name),
    },
    {
      title: "Section",
      dataIndex: ["section", "name"],
      key: "section",
      width: 120,
      sorter: (a, b) => a.section.name.localeCompare(b.section.name),
    },
    {
      title: "Role",
      dataIndex: "roles",
      key: "roles",
      width: 100,
      sorter: (a, b) => {
        const roleNamesA = (a.roles || []).map((role) => role.name).join(", ");
        const roleNamesB = (b.roles || []).map((role) => role.name).join(", ");
        return roleNamesA.localeCompare(roleNamesB);
      },
      render: (text, record) => (
        <>
          {record?.roles?.map((role) => (
            <Tag color={role.color} key={role.id}>
              {role.name}
            </Tag>
          ))}
        </>
      ),
    },
    {
      title: "Restore",
      key: "Actions",
      width: 80,
      render: (text, record) => (
        <Space>
          <Tooltip title="Restore">
            <RollbackOutlined
              onClick={() => handleRestore(record)}
              style={{ color: "red", cursor: "pointer" }}
            />
          </Tooltip>
        </Space>
      ),
      fixed: "right",
    },
  ];

  const [visibleColumns, setVisibleColumns] = useState(() =>
    columns.map((column) => column.key)
  );

  const menu = (
    <Menu>
      {columns.map((column) => (
        <Menu.Item key={column.key}>
          <Checkbox
            className="mr-5"
            style={{ fontSize: "12px" }}
            onChange={() => handleColumnToggle(column.key)}
            checked={visibleColumns.includes(column.key)}
          >
            {column.title}
          </Checkbox>
        </Menu.Item>
      ))}
    </Menu>
  );

  const handleColumnToggle = (key) => {
    const updatedVisibleColumns = [...visibleColumns];

    if (visibleColumns.includes(key)) {
      const index = updatedVisibleColumns.indexOf(key);
      if (index > -1) {
        updatedVisibleColumns.splice(index, 1);
      }
    } else {
      updatedVisibleColumns.push(key);
    }

    setVisibleColumns(updatedVisibleColumns);

    try {
      localStorage.setItem(
        "visibleColumnsrusers",
        JSON.stringify(updatedVisibleColumns)
      );
    } catch (error) {
      console.error("Error saving visibleColumns to local storage:", error);
    }
  };

  useEffect(() => {
    try {
      const savedVisibleColumns = localStorage.getItem("visibleColumnsrusers");
      if (savedVisibleColumns) {
        setVisibleColumns(JSON.parse(savedVisibleColumns));
      }
    } catch (error) {
      console.error("Error loading visibleColumns from local storage:", error);
    }
  }, []);

  const handleAction = (record) => {};

  return (
    <DefaultLayout>
      <Card>
        <Input
          size="large"
          placeholder="Search"
          value={searchQuery}
          onChange={handleInputChange}
        />
      </Card>

      <Card>
        <Dropdown
          className="mr-10"
          menu={menu}
          open={visible}
          onOpenChange={(isVisible) => setVisible(isVisible)}
          trigger={["click"]}
        >
          <a
            style={{ color: "black", fontSize: "11px", color: "gray" }}
            onClick={(e) => e.preventDefault()}
          >
            <UnorderedListOutlined /> Columns
          </a>
        </Dropdown>

        <Table
          style={{ minHeight: "100vh" }}
          onChange={handleTableChange}
          columns={columns.filter((column) =>
            visibleColumns.includes(column.key)
          )}
          dataSource={data.map((item) => ({ ...item, key: item.id }))}
          rowKey={(record) => record.key}
          scroll={{ x: 1200 }}
          sticky={true}
          pagination={{
            showSizeChanger: false,
            current: currentPage,
            total: totalDataCount,
            pageSize: itemsPerPage,
          }}
          loading={loading}
        />
      </Card>
    </DefaultLayout>
  );
};

export default RestoreUsersData;
